module.exports = __webpack_public_path__ + "assets/img/w-c-s3.6f7c9a0c.png";